import React, { useState, useEffect } from "react";
import axios from "axios";
import configData from "./Config.json";

import './Request.css';

function Request() {
    const [email, setEmail] = useState('');
    const [projectuserid, setProjectuserid] = useState('');
    const [projectid, setProjectid] = useState('');

    const [notregistered, setNotregistered] = useState(false);
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const puid = params.get("puid");
        const pid = params.get("pid");

        if (puid) setProjectuserid(puid);
        if (pid) setProjectid(pid);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setResult("Please enter a valid email address");
            return;
        }

        if (!email || !projectuserid || !projectid) {
            setResult('Please fill all fields')
            return;
        }

        setLoading(true);
        setResult(null);

        await new Promise(resolve => setTimeout(resolve, 2000));

        const data = {
            projectuserid: projectuserid,
            projectid: projectid,
            email: email,
        }

        axios.post(configData.CONTROLLERURL + configData.REQUESTLINK, data, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json;charset=UTF-8",
            },
        }).then(res => {
            console.log(res.data)
            if (res.data instanceof Object) {
                if (res.data.code == 1) {
                    setNotregistered(true)
                    setResult(res.data.data)
                }
                if (res.data.code == 2) {
                    setResult(res.data.data)
                }
                if (res.data.code == 3) {
                    setResult(res.data.data)
                }
                if (res.data.code == 4) {
                    setResult(res.data.data)
                }
            }
            else {
                setResult('Error, please contact support')
            }
        }).catch((err) => {
            setResult(err.response?.data?.message || err.message || 'Network error');
        }).finally(() => {
            setLoading(false)
        })
    };

    return (
        <div className="request">
            <div className="request_title">
                <div className="request_titletext">Request Property Link</div>
            </div>

            <form className="request_form" onSubmit={handleSubmit}>
                <label className="label">
                    Email
                </label>
                <input
                    className="input"
                    type="text"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoCapitalize="none"
                    autoCorrect="off"
                />

                <label className="label">
                    Project Id
                </label>
                <input
                    className="input"
                    type="password"
                    value={projectid}
                    readOnly
                    disabled
                />

                <label className="label">
                    Project User Id
                </label>
                <input
                    className="input"
                    type="password"
                    value={projectuserid}
                    readOnly
                    disabled
                />

                {result && <div className='result'>{result}</div>}

                {!notregistered &&
                    <button
                        className="request_submitbutton"
                        type="submit"
                        disabled={loading}
                    >
                        {loading ? "Submitting..." : "Submit Request"}
                    </button>
                }
                {
                    notregistered &&
                    <a
                        href="/app"
                        className="request_submitbutton"
                    >
                        Go to Registration
                    </a>
                }
            </form>
        </div>
    );
}

export default Request;